<template>
    <sideBarView />
  
    <navbarView />
  
    <main class="main-sec" id="main">
      <div class="container">
        <div class="flex-bet-main mb-2">
          <div class="side-heading">
            <h6>{{ $t('notificationsView.title') }}</h6>
            <p class="font13 gray-col">{{ $t('notificationsView.subtitle') }}</p>
          </div>
        </div>
        <template v-if="!loader">
            <div class="notifications" v-if="notifications?.length">
              <template v-for="noti in notifications" :key="noti.id">

                <router-link to="/packagesDashboard" class="noti-box mb-3" v-if="noti?.type == 'create'" >
                    <div class="bell-cont">
                        <i class="fa-solid fa-bell"></i>
                    </div>
                    <div class="left-noti">
                        <p class="mb-2">
                            {{ noti?.body   }}
                        </p>
                        <div class="time-noti">
                            <i class="fa-regular fa-clock"></i>
                            <div class="real-t">
                                {{ noti?.created_at   }}
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="'/MaintenanceDetails/' + noti?.data?.order_id" class="noti-box mb-3" v-else-if="noti?.type == 'create_maintenance_request'" >
                    <div class="bell-cont">
                        <i class="fa-solid fa-bell"></i>
                    </div>
                    <div class="left-noti">
                        <p class="mb-2">
                            {{ noti?.body   }}
                        </p>
                        <div class="time-noti">
                            <i class="fa-regular fa-clock"></i>
                            <div class="real-t">
                                {{ noti?.created_at   }}
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="'/buildingDetails/' + noti?.data?.building_id" class="noti-box mb-3" v-else-if="noti?.type == 'create_building'" >
                    <div class="bell-cont">
                        <i class="fa-solid fa-bell"></i>
                    </div>
                    <div class="left-noti">
                        <p class="mb-2">
                            {{ noti?.body   }}
                        </p>
                        <div class="time-noti">
                            <i class="fa-regular fa-clock"></i>
                            <div class="real-t">
                                {{ noti?.created_at   }}
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link to="/reviewsView" class="noti-box mb-3" v-else-if="noti?.type == 'rate_manager'" >
                    <div class="bell-cont">
                        <i class="fa-solid fa-bell"></i>
                    </div>
                    <div class="left-noti">
                        <p class="mb-2">
                            {{ noti?.body   }}
                        </p>
                        <div class="time-noti">
                            <i class="fa-regular fa-clock"></i>
                            <div class="real-t">
                                {{ noti?.created_at   }}
                            </div>
                        </div>
                    </div>
                </router-link>
                <router-link :to="'/manageMessage?text=' + noti?.body" v-else class="noti-box mb-3">
                    <div class="bell-cont">
                        <i class="fa-solid fa-bell"></i>
                    </div>
                    <div class="left-noti">
                        <p class="mb-2">
                            {{ noti?.body   }}
                        </p>
                        <div class="time-noti">
                            <i class="fa-regular fa-clock"></i>
                            <div class="real-t">
                                {{ noti?.created_at   }}
                            </div>
                        </div>
                    </div>
                </router-link>
              </template>
            </div>
            <p v-else class="font15 gray-col mt-4 text-center">{{ $t('notificationsView.noNotifications') }}</p>
        </template>
        
      </div>
    </main>
  

  </template>
  
  <script setup>
  // imports
  import sideBarView from "../components/dashboard/sideBarView.vue";
  import navbarView from "../components/dashboard/navbarView.vue";
  
  import {  onMounted , ref } from "vue";
  
  // reactive state
  import axios from "axios";

  
  // reactive state
  const loader = ref(true);
  
  const notifications = ref([]);
  
  // computed
  
  // methods
  const getData = async () => {
    try {
      const res = await axios.get("/notifications" , {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      notifications.value = res.data?.data?.notifications?.data;
      loader.value = false;
    } catch (error) {
      console.log(error);
    }
  };

  
  // functions

  // lifecycle hooks
  onMounted(() => {
    getData();
  });
  </script>
  